// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__2-cCy","assignButton":"CreateEditEquipmentSchedule_assignButton__1ES85"};